import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import useCheckSubscriberAccess from '../../partymode/hooks/useCheckSubscriberAccess';
import { refreshPublicSessions } from "../../partymode/redux/actions/index";

const useManageGroup = () => {
  const dispatch = useDispatch();
  const [showGroup, setShowGroup] = useState(0);
  const [accessGroupPM, setAccessGroupPM] = useState(false);
  const tab = useSelector( state => (state.enablePM && state.isSubscribed) ? 1 : 0 );
  const isSubscribed = useSelector( state => state.isSubscribed );
  useEffect(() => {
    setShowGroup(tab);
  }, [tab])

  const accessGroup = (group) => () => {
    if (group === 0) {
      setShowGroup(0);
    } else if (group === 1 && isSubscribed) {
      setShowGroup(1);
      dispatch(refreshPublicSessions(Date.now()));
    }
    setAccessGroupPM(!!group);
  }

  const reset = () => setAccessGroupPM(false);
  useCheckSubscriberAccess(accessGroupPM, reset);

  return { showGroup, accessGroup };
};

export default useManageGroup;
